import { useGetMultiUserCardInfo } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

/* Types */
type UseGetMultiInfoCardProps = {
  cardIds: number[];
};

/* Hooks */
export const useGetMultiInfoCard = ({ cardIds }: UseGetMultiInfoCardProps) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const {
    isLoading,
    data: cardsData,
    isError,
    error,
  } = useGetMultiUserCardInfo({
    enabled: !!id && !!cardIds.length,
    userId: id ?? 0,
    sensitiveInfo: false,
    cardIds,
  });

  /* Return */
  return {
    isLoading,
    cardsData,
    isError,
    error,
  };
};
